function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { PageHeader, Ribbon, Card, Empty } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import Auth from "../../functions/authenticate";
import { repSvc, safe, canManageReport, errText, apiRoot, authHeaders } from "./common";
import ScheduleSheet, { parseSchedule, browserTz, asUtcDate, fmtWhen, fmtDayShort, fmtShortDate, fmtHourShort, scheduleParts, whenLabel, coversHint, tzCity, sendTestEmail } from "./schedule-sheet";
import account from "../../data/account";

/*
 * Reports page (§223/§224 + REPORT_SCHEDULES_UX.md §2 ①; reportsflow boards
 * 1, 7, 8 of 2026-10-09). Three tabs:
 *  Reports  saved rows + "Start from a template" strip; "···" row menu.
 *  Emails   (?tab=schedules) every report that is emailed on a schedule.
 *  Sent     the delivery log (report_delivery), newest first.
 * The email editor is the side sheet (schedule-sheet.jsx). Styles: sass/v2/_reports-list.scss (rl-).
 */

const TABS = [["reports", "Reports"], ["schedules", "Emails"], ["sent", "Sent"]];
const TEMPLATES = [["monthly", "Monthly performance", "Visits, visitors, conversions and sales, against last month"], ["products", "Products people look at", "Most viewed products and how interest changes by day"], ["marketing", "Marketing overview", "Ads, email and social side by side"], ["sales", "Sales by customer", "Top customers, orders and revenue by region"], ["blank", "Blank report", "Choose every panel yourself"]];

// Reports store the creator's email, or (sessions without an email claim)
// the Cognito `sub` GUID. Show "You" for the caller's own, "Plunk" for the
// seeded ones, a neutral label for someone else's GUID, else the email.
const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function ownerLabel(createdBy) {
  if (!createdBy) return "Your team";
  const me = account.get() || {};
  if (GUID_RE.test(createdBy)) return me.sub && createdBy === me.sub ? "You" : "A teammate";
  if (String(createdBy).toLowerCase() === "plunk") return "Plunk";
  const email = account.getEmail && account.getEmail() || me.email || "";
  if (email && String(createdBy).toLowerCase() === String(email).toLowerCase()) return "You";
  return createdBy;
}
// `mine` from the API is the manage truth (§294); canManageReport is the fallback.
const canManage = row => row && row.mine != null ? !!row.mine : canManageReport(row);
function lastOpened(v) {
  const d = asUtcDate(v);
  if (!d || isNaN(d.getTime())) return null;
  const day = x => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((day(new Date()) - day(d)) / 86400000);
  if (diff === 0) return "Today";
  if (diff === 1) return "Yesterday";
  return fmtShortDate(d);
}
const people = n => `${n} ${n === 1 ? "person" : "people"}`;
function namesLine(list, max = 2) {
  const l = list || [];
  return {
    shown: l.slice(0, max).join(", "),
    more: Math.max(0, l.length - max)
  };
}
const Chip = ({
  tone = "grey",
  children,
  title
}) => /*#__PURE__*/React.createElement("span", {
  className: `rl-chip ${tone}`,
  title: title
}, children);

/** "···" row menu. Fixed-position pop so the table's scroll box never clips it. */
// Failed sends that are still the newest non-test send for their report (log is newest first).
function openFailures(log) {
  const seen = new Set();
  const out = [];
  (log || []).forEach(d => {
    if (d.status === "test") return;
    const k = String(d.reportId);
    if (seen.has(k)) return;
    seen.add(k);
    if (d.status === "failed") out.push(d);
  });
  return out;
}
class RowMenu extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      open: false,
      pos: null
    });
    _defineProperty(this, "onDoc", e => {
      if (this._wrap && !this._wrap.contains(e.target)) this.close();
    });
    _defineProperty(this, "onKeyDoc", e => {
      if (e.key === "Escape") this.close();
    });
    _defineProperty(this, "close", () => {
      if (this.state.open) {
        this.unbind();
        this.setState({
          open: false
        });
      }
    });
    _defineProperty(this, "toggle", e => {
      e.stopPropagation();
      if (this.state.open) {
        this.close();
        return;
      }
      const r = e.currentTarget.getBoundingClientRect();
      const below = window.innerHeight - r.bottom > 260;
      this.setState({
        open: true,
        pos: below ? {
          top: r.bottom + 6,
          right: window.innerWidth - r.right
        } : {
          bottom: window.innerHeight - r.top + 6,
          right: window.innerWidth - r.right
        }
      });
      this.bind();
    });
  }
  componentWillUnmount() {
    this.unbind();
  }
  bind() {
    document.addEventListener("mousedown", this.onDoc);
    document.addEventListener("keydown", this.onKeyDoc);
    window.addEventListener("scroll", this.close, true);
    window.addEventListener("resize", this.close);
  }
  unbind() {
    document.removeEventListener("mousedown", this.onDoc);
    document.removeEventListener("keydown", this.onKeyDoc);
    window.removeEventListener("scroll", this.close, true);
    window.removeEventListener("resize", this.close);
  }
  render() {
    const {
      label,
      items
    } = this.props;
    const {
      open,
      pos
    } = this.state;
    const list = (items || []).filter(Boolean);
    if (!list.length) return null;
    return /*#__PURE__*/React.createElement("span", {
      className: "rl-menu",
      ref: el => {
        this._wrap = el;
      },
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "rl-menu-btn",
      "aria-label": `More for ${label}`,
      "aria-haspopup": "menu",
      "aria-expanded": open,
      onClick: this.toggle
    }, "\xB7\xB7\xB7"), open ? /*#__PURE__*/React.createElement("div", {
      className: "rl-menu-pop",
      role: "menu",
      style: pos
    }, list.map(it => /*#__PURE__*/React.createElement("button", {
      key: it.label,
      type: "button",
      role: "menuitem",
      className: it.danger ? "danger" : "",
      disabled: it.disabled,
      onClick: () => {
        this.close();
        it.onClick && it.onClick();
      }
    }, it.label))) : null);
  }
}

/** Inline "Delete? Yes, delete · Keep" confirm that replaces a row's menu. */
const Confirm = ({
  q,
  yes,
  onYes,
  onNo,
  busy
}) => /*#__PURE__*/React.createElement("span", {
  className: "rl-confirm",
  onClick: e => e.stopPropagation()
}, /*#__PURE__*/React.createElement("span", null, q), /*#__PURE__*/React.createElement("a", {
  className: "rl-danger",
  onClick: () => !busy && onYes()
}, busy ? "Working…" : yes), /*#__PURE__*/React.createElement("a", {
  onClick: onNo
}, "Keep"));
class ReportsListComponent extends React.Component {
  constructor(props) {
    super(props);
    // ── report actions ──
    _defineProperty(this, "remove", async row => {
      this.setState({
        busy: String(row.id),
        note: null
      });
      try {
        await repSvc(`/${String(row.id)}`).deleteAsync();
        if (!this._alive) return;
        this.setState({
          busy: null,
          confirm: null
        });
        this.say(`${row.name} was deleted.`);
        this.load();
      } catch (e) {
        if (this._alive) this.setState({
          busy: null,
          note: errText(e, "That report couldn't be deleted."),
          noteKind: "error"
        });
      }
    });
    _defineProperty(this, "duplicate", async row => {
      const id = String(row.id);
      this.setState({
        busy: id,
        note: null
      });
      try {
        const def = await repSvc(`/${id}`).getAsync();
        if (!def) throw new Error("That report couldn't be read.");
        const body = {
          ...def
        };
        ["id", "Id", "createdBy", "CreatedBy", "scheduleJson", "ScheduleJson", "lastRunDate", "createdDate", "modifiedDate", "mine"].forEach(k => {
          delete body[k];
        });
        body.name = `${def.name || row.name} (copy)`;
        body.starter = false;
        await repSvc("").postAsync(body);
        if (!this._alive) return;
        this.setState({
          busy: null
        });
        this.say(`Made a copy: ${body.name}.`);
        this.load();
      } catch (e) {
        if (this._alive) this.setState({
          busy: null,
          note: errText(e, "That report couldn't be copied."),
          noteKind: "error"
        });
      }
    });
    _defineProperty(this, "downloadCsv", async row => {
      try {
        const res = await fetch(`${apiRoot()}/reports/${String(row.id)}/export.csv`, {
          headers: authHeaders()
        });
        if (!res.ok) throw new Error(`The download didn't work (${res.status}).`);
        const blob = await res.blob();
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `${row.name || "report"}.csv`;
        a.click();
        setTimeout(() => URL.revokeObjectURL(a.href), 2000);
      } catch (e) {
        this.say(errText(e, "The download didn't work."), "error");
      }
    });
    // ── email actions ──
    _defineProperty(this, "act", async (item, what) => {
      const id = String(item.id);
      const s = item.schedule || parseSchedule(item.scheduleJson) || {};
      this.setState({
        busy: id,
        note: null
      });
      try {
        if (what === "pause" || what === "resume") {
          await repSvc(`/${id}/schedule/pause`).postAsync({
            paused: what === "pause"
          });
          this.say(what === "pause" ? `${item.name} is paused. Nothing is sent until you turn it back on.` : `${item.name} is sending again.`);
        } else if (what === "test") {
          const me = await sendTestEmail(id);
          this.say(`A test of ${item.name} is on its way to ${me || "you"}. It arrives within 5 minutes.`);
          setTimeout(() => {
            if (this._alive) this.load();
          }, 60000);
        } else if (what === "stop") {
          await repSvc(`/${id}/schedule`).deleteAsync();
          this.setState({
            confirm: null
          });
          this.say(`${item.name} is no longer emailed.`);
        } else {
          await repSvc(`/${id}/schedule/send-now`).postAsync({
            test: false
          });
          const n = (s.recipients || []).length;
          this.say(`${item.name} is on its way to ${people(n)}. It arrives within 5 minutes.`);
          setTimeout(() => {
            if (this._alive) this.load();
          }, 60000);
        }
        if (this._alive) {
          this.setState({
            busy: null
          });
          this.load();
        }
      } catch (e) {
        if (this._alive) this.setState({
          busy: null,
          note: errText(e, "That didn't work. Try again."),
          noteKind: "error"
        });
      }
    });
    const tab = /tab=(\w+)/.exec(props.location?.search || "")?.[1];
    this.state = {
      tab: TABS.some(([k]) => k === tab) ? tab : "reports",
      rows: null,
      schedules: null,
      sent: null,
      error: false,
      busy: null,
      confirm: null,
      note: null,
      noteKind: "info",
      sheet: null,
      tz: browserTz(),
      q: "",
      sentFilter: "all"
    };
    this._alive = true;
  }
  async componentDidMount() {
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async load() {
    const [d, s, sent] = await Promise.all([safe(repSvc("").getAsync(), null), safe(repSvc("/schedules").getAsync(), null), safe(repSvc("/deliveries?limit=100").getAsync(), null)]);
    if (!this._alive) return;
    if (d === null) {
      this.setState({
        error: true
      });
      return;
    }
    this.setState({
      rows: d.items || d || [],
      schedules: s,
      sent: sent ? sent.items || [] : []
    });
  }
  setTab(tab) {
    this.setState({
      tab,
      note: null,
      confirm: null
    });
    try {
      this.props.history.replace({
        pathname: "/Reports",
        search: tab === "reports" ? "" : `?tab=${tab}`
      });
    } catch (e) {/* no router */}
  }
  say(note, kind = "info") {
    if (this._alive) this.setState({
      note,
      noteKind: kind
    });
  }
  openSheet(report, schedule) {
    this.setState({
      sheet: {
        report,
        schedule: schedule || parseSchedule(report.scheduleJson)
      }
    });
  }
  open(id) {
    this.props.history.push(`/Reports/view/${id}`);
  }

  // ── Reports tab ──
  emailedCell(row, manage) {
    const s = parseSchedule(row.scheduleJson);
    if (!s) {
      return manage ? /*#__PURE__*/React.createElement("span", {
        className: "rl-muted"
      }, "Not emailed \xB7 ", /*#__PURE__*/React.createElement("a", {
        className: "rl-link",
        onClick: e => {
          e.stopPropagation();
          this.openSheet(row, null);
        }
      }, "Email it")) : /*#__PURE__*/React.createElement("span", {
        className: "rl-muted"
      }, "Not emailed");
    }
    const p = scheduleParts(s, this.state.tz);
    const n = (s.recipients || []).length;
    const click = manage ? e => {
      e.stopPropagation();
      this.openSheet(row, s);
    } : undefined;
    const tzTail = p.away ? ` ${tzCity(p.tz)}` : "";
    return /*#__PURE__*/React.createElement("span", {
      className: "rl-emailed" + (manage ? " clickable" : ""),
      onClick: click
    }, s.paused ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Chip, {
      tone: "amber"
    }, "Paused"), /*#__PURE__*/React.createElement("span", {
      className: "rl-muted"
    }, p.day.charAt(0).toLowerCase() + p.day.slice(1))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Chip, {
      tone: "green"
    }, p.day), /*#__PURE__*/React.createElement("span", {
      className: "rl-muted"
    }, "at ", fmtHourShort(p.hour), tzTail, " to ", people(n))));
  }
  renderReports() {
    const {
      rows,
      confirm,
      busy,
      q
    } = this.state;
    const needle = q.trim().toLowerCase();
    const list = needle ? rows.filter(r => `${r.name || ""} ${r.description || ""}`.toLowerCase().includes(needle)) : rows;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
      title: "Start from a template",
      hint: "Pick one, then change anything you like",
      cls: "rl-tpl-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rl-templates"
    }, TEMPLATES.map(([k, name, desc]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      className: "rl-tpl" + (k === "blank" ? " blank" : ""),
      onClick: () => this.props.history.push(`/Reports/new?template=${k}`)
    }, /*#__PURE__*/React.createElement("b", null, name), /*#__PURE__*/React.createElement("span", null, desc))))), /*#__PURE__*/React.createElement(Card, {
      title: "Your reports",
      hint: `${rows.length} ${rows.length === 1 ? "report" : "reports"}`,
      cls: "rl-card",
      right: /*#__PURE__*/React.createElement("input", {
        className: "rl-search",
        type: "search",
        value: q,
        placeholder: "Search reports",
        "aria-label": "Search reports",
        onChange: e => this.setState({
          q: e.target.value
        })
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table rl-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Report"), /*#__PURE__*/React.createElement("th", null, "Last opened"), /*#__PURE__*/React.createElement("th", null, "Emailed"), /*#__PURE__*/React.createElement("th", null, "Made by"), /*#__PURE__*/React.createElement("th", {
      className: "rl-act"
    }))), /*#__PURE__*/React.createElement("tbody", null, list.map(r => {
      const id = String(r.id);
      const manage = canManage(r);
      const opened = lastOpened(r.lastRunDate);
      return /*#__PURE__*/React.createElement("tr", {
        key: id,
        className: "clickable",
        onClick: () => this.open(id),
        title: "Open report"
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, r.name, r.shared === false || r.shared === 0 ? /*#__PURE__*/React.createElement(Chip, {
        tone: "grey"
      }, "Just you") : null), r.description ? /*#__PURE__*/React.createElement("span", {
        className: "rl-desc"
      }, r.description) : null), /*#__PURE__*/React.createElement("td", null, opened || /*#__PURE__*/React.createElement("span", {
        className: "rl-muted"
      }, "Not yet")), /*#__PURE__*/React.createElement("td", null, this.emailedCell(r, manage)), /*#__PURE__*/React.createElement("td", null, ownerLabel(r.createdBy)), /*#__PURE__*/React.createElement("td", {
        className: "rl-act",
        onClick: e => e.stopPropagation()
      }, confirm === `del:${id}` ? /*#__PURE__*/React.createElement(Confirm, {
        q: "Delete this report?",
        yes: "Yes, delete",
        busy: busy === id,
        onYes: () => this.remove(r),
        onNo: () => this.setState({
          confirm: null
        })
      }) : /*#__PURE__*/React.createElement(RowMenu, {
        label: r.name,
        items: [{
          label: "Open",
          onClick: () => this.open(id)
        }, manage && {
          label: "Edit",
          onClick: () => this.props.history.push(`/Reports/edit/${id}`)
        }, manage && {
          label: "Email it…",
          onClick: () => this.openSheet(r, null)
        }, {
          label: "Duplicate",
          disabled: busy === id,
          onClick: () => this.duplicate(r)
        }, {
          label: "Download as CSV",
          onClick: () => this.downloadCsv(r)
        }, manage && {
          label: "Delete",
          danger: true,
          onClick: () => this.setState({
            confirm: `del:${id}`
          })
        }]
      })));
    })))), !rows.length && /*#__PURE__*/React.createElement(Empty, null, "No reports yet. Start from a template above, or choose New report."), rows.length > 0 && !list.length && /*#__PURE__*/React.createElement(Empty, null, "No reports match \u201C", q, "\u201D.")));
  }

  // ── Emails tab ──
  lastSentCell(ld) {
    if (!ld) return /*#__PURE__*/React.createElement("span", {
      className: "rl-muted"
    }, "Not yet");
    const failed = ld.status === "failed";
    return /*#__PURE__*/React.createElement("span", {
      className: "rl-inline",
      title: failed && ld.error ? ld.error : undefined
    }, failed ? /*#__PURE__*/React.createElement(Chip, {
      tone: "red"
    }, "Didn't go out") : ld.status === "test" ? /*#__PURE__*/React.createElement(Chip, {
      tone: "grey"
    }, "Test") : /*#__PURE__*/React.createElement(Chip, {
      tone: "green"
    }, "Delivered"), fmtShortDate(ld.sentAt));
  }
  renderSchedules() {
    const {
      schedules,
      busy,
      tz,
      confirm,
      sent
    } = this.state;
    if (!schedules) return /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, "The emails couldn't be loaded. Try again in a minute.");
    const sum = schedules.summary || {};
    const items = schedules.items || [];
    const nextItem = sum.nextSendUtc ? items.find(it => it.nextDueUtc && Math.abs(asUtcDate(it.nextDueUtc) - asUtcDate(sum.nextSendUtc)) < 60000) : null;
    const now = new Date();
    const failedThisMonth = (sent || []).filter(d => {
      const t = asUtcDate(d.sentAt);
      return d.status === "failed" && t && t.getFullYear() === now.getFullYear() && t.getMonth() === now.getMonth();
    }).length;
    const nextLocal = nextItem ? asUtcDate(nextItem.nextDueUtc).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit"
    }) : "";
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Ribbon, {
      comparing: null,
      cols: 4,
      tiles: [{
        l: "Sending",
        v: String(sum.active || 0),
        s: sum.paused ? `${sum.paused} paused` : "none paused"
      }, {
        l: "Next email",
        v: sum.nextSendUtc ? fmtDayShort(sum.nextSendUtc) : "None",
        s: nextItem ? `${nextItem.name} at ${nextLocal}` : "nothing coming up"
      }, {
        l: "Sent this month",
        v: String(sum.sentThisMonth || 0),
        s: failedThisMonth ? `${failedThisMonth} didn't go out` : "all delivered"
      }, {
        l: "People on the list",
        v: String(sum.recipients || 0),
        s: "across all reports"
      }]
    }), /*#__PURE__*/React.createElement(Card, {
      title: "Reports you email",
      cls: "rl-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table rl-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Report"), /*#__PURE__*/React.createElement("th", null, "When"), /*#__PURE__*/React.createElement("th", null, "Who gets it"), /*#__PURE__*/React.createElement("th", null, "Last sent"), /*#__PURE__*/React.createElement("th", null, "Next"), /*#__PURE__*/React.createElement("th", {
      className: "rl-act"
    }))), /*#__PURE__*/React.createElement("tbody", null, items.map(it => {
      const id = String(it.id);
      const s = it.schedule || {};
      const ld = it.lastDelivery;
      const who = namesLine(s.recipients);
      const mine = canManage(it);
      return /*#__PURE__*/React.createElement("tr", {
        key: id,
        className: "clickable",
        onClick: () => mine ? this.openSheet(it, s) : this.open(id),
        title: mine ? "Change this email" : "Open report"
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, it.name), it.description ? /*#__PURE__*/React.createElement("span", {
        className: "rl-desc"
      }, it.description) : null), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "rl-strong"
      }, whenLabel(s, tz)), /*#__PURE__*/React.createElement("span", {
        className: "rl-desc"
      }, coversHint(s.range))), /*#__PURE__*/React.createElement("td", {
        title: (s.recipients || []).join(", ")
      }, /*#__PURE__*/React.createElement("span", null, who.shown || /*#__PURE__*/React.createElement("span", {
        className: "rl-muted"
      }, "Nobody yet")), who.more ? /*#__PURE__*/React.createElement("span", {
        className: "rl-desc"
      }, "and ", who.more, " more") : null), /*#__PURE__*/React.createElement("td", null, this.lastSentCell(ld)), /*#__PURE__*/React.createElement("td", null, s.paused ? /*#__PURE__*/React.createElement(Chip, {
        tone: "amber"
      }, "Paused") : s.sendNowPending ? /*#__PURE__*/React.createElement("span", {
        className: "rl-muted"
      }, "Sending now") : it.nextDueUtc ? fmtDayShort(it.nextDueUtc) : /*#__PURE__*/React.createElement("span", {
        className: "rl-muted"
      }, "Not set")), /*#__PURE__*/React.createElement("td", {
        className: "rl-act",
        onClick: e => e.stopPropagation()
      }, confirm === `stop:${id}` ? /*#__PURE__*/React.createElement(Confirm, {
        q: "Stop emailing?",
        yes: "Yes, stop",
        busy: busy === id,
        onYes: () => this.act(it, "stop"),
        onNo: () => this.setState({
          confirm: null
        })
      }) : /*#__PURE__*/React.createElement(RowMenu, {
        label: it.name,
        items: [mine && {
          label: s.sendNowPending ? "Sending now…" : "Send now",
          disabled: busy === id || s.sendNowPending,
          onClick: () => this.act(it, "send")
        }, mine && {
          label: "Send a test to me",
          disabled: busy === id,
          onClick: () => this.act(it, "test")
        }, mine && {
          label: "Change",
          onClick: () => this.openSheet(it, s)
        }, mine && {
          label: s.paused ? "Resume" : "Pause",
          disabled: busy === id,
          onClick: () => this.act(it, s.paused ? "resume" : "pause")
        }, {
          label: "Open the report",
          onClick: () => this.open(id)
        }, mine && {
          label: "Stop emailing",
          danger: true,
          onClick: () => this.setState({
            confirm: `stop:${id}`
          })
        }]
      })));
    })))), !items.length && /*#__PURE__*/React.createElement(Empty, null, "No reports are emailed yet. Open a report and choose Email it, or use Email it on the Reports tab.")));
  }

  // ── Sent tab ──
  scheduleFor(reportId) {
    return (this.state.schedules && this.state.schedules.items || []).find(it => String(it.id) === String(reportId)) || null;
  }
  whyLabel(d) {
    if (d.status === "test") return "Test to me";
    if (!d.occurrenceUtc) return "Sent by hand";
    const it = this.scheduleFor(d.reportId);
    const c = it && it.schedule && it.schedule.cadence;
    return c === "weekly" ? "Weekly email" : c === "monthly" ? "Monthly email" : "Scheduled email";
  }
  renderSent() {
    const {
      sent,
      tz,
      sentFilter,
      busy
    } = this.state;
    const all = sent || [];
    const failed = all.filter(d => d.status === "failed");
    const list = sentFilter === "failed" ? failed : all;
    // Only failures that are still the latest send for their report need attention;
    // one followed by a delivered send is history and stays in the list below.
    const open = openFailures(all);
    const first = open[0];
    let banner = null;
    if (first) {
      const it = this.scheduleFor(first.reportId);
      const name = first.reportName || it && it.name || "A report";
      const others = open.length > 1 ? ` ${open.length - 1} more ${open.length - 1 === 1 ? "report has" : "reports have"} the same problem.` : "";
      banner = /*#__PURE__*/React.createElement("div", {
        className: "rl-banner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons rl-banner-ic",
        "aria-hidden": "true"
      }, "error_outline"), /*#__PURE__*/React.createElement("div", {
        className: "rl-banner-t"
      }, /*#__PURE__*/React.createElement("b", null, open.length, " ", open.length === 1 ? "email" : "emails", " didn't go out"), /*#__PURE__*/React.createElement("span", {
        title: first.error || undefined
      }, name, " on ", fmtShortDate(first.sentAt), " couldn't be built, so nobody got it.", others)), it && canManage(it) && /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        disabled: busy === String(it.id),
        onClick: () => this.act(it, "send")
      }, "Send it again"));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, banner, /*#__PURE__*/React.createElement(Card, {
      title: "Sent emails",
      cls: "rl-card",
      right: /*#__PURE__*/React.createElement("span", {
        className: "rl-filters"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "rl-filter" + (sentFilter === "all" ? " on" : ""),
        onClick: () => this.setState({
          sentFilter: "all"
        })
      }, "All ", all.length), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "rl-filter" + (sentFilter === "failed" ? " on" : ""),
        onClick: () => this.setState({
          sentFilter: "failed"
        })
      }, "Didn't go out ", failed.length))
    }, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table rl-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Sent"), /*#__PURE__*/React.createElement("th", null, "Report"), /*#__PURE__*/React.createElement("th", null, "Result"), /*#__PURE__*/React.createElement("th", null, "To"), /*#__PURE__*/React.createElement("th", null, "Why it was sent"), /*#__PURE__*/React.createElement("th", {
      className: "rl-act"
    }))), /*#__PURE__*/React.createElement("tbody", null, list.map(d => {
      const bad = d.status === "failed";
      const to = namesLine(d.recipients);
      const it = bad ? this.scheduleFor(d.reportId) : null;
      return /*#__PURE__*/React.createElement("tr", {
        key: d.id,
        className: "clickable",
        onClick: () => this.open(d.reportId),
        title: "Open report"
      }, /*#__PURE__*/React.createElement("td", {
        className: "rl-nowrap"
      }, fmtWhen(d.sentAt, tz)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "rl-strong"
      }, d.reportName || "Report"), bad ? /*#__PURE__*/React.createElement("span", {
        className: "rl-desc bad",
        title: d.error || undefined
      }, "The email couldn't be built") : null), /*#__PURE__*/React.createElement("td", null, bad ? /*#__PURE__*/React.createElement(Chip, {
        tone: "red"
      }, "Didn't go out") : d.status === "test" ? /*#__PURE__*/React.createElement(Chip, {
        tone: "grey"
      }, "Test") : /*#__PURE__*/React.createElement(Chip, {
        tone: "green"
      }, "Delivered")), /*#__PURE__*/React.createElement("td", {
        title: (d.recipients || []).join(", ")
      }, to.shown || /*#__PURE__*/React.createElement("span", {
        className: "rl-muted"
      }, "Nobody"), to.more ? /*#__PURE__*/React.createElement("span", {
        className: "rl-muted"
      }, " +", to.more) : null), /*#__PURE__*/React.createElement("td", null, this.whyLabel(d)), /*#__PURE__*/React.createElement("td", {
        className: "rl-act",
        onClick: e => e.stopPropagation()
      }, bad && it && canManage(it) && open.includes(d) ? /*#__PURE__*/React.createElement("a", {
        className: "rl-link",
        style: busy === String(it.id) ? {
          opacity: .5,
          pointerEvents: "none"
        } : undefined,
        onClick: () => this.act(it, "send")
      }, "Retry") : null));
    })))), !all.length && /*#__PURE__*/React.createElement(Empty, null, "No emails sent yet. When a report is emailed, each send shows up here."), all.length > 0 && !list.length && /*#__PURE__*/React.createElement(Empty, null, "Every email went out.")));
  }
  render() {
    const {
      rows,
      error,
      note,
      noteKind,
      tab,
      sheet,
      schedules
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (rows === null) return /*#__PURE__*/React.createElement(Loader, null);
    const anyFailed = openFailures(this.state.sent || []).length > 0 || !!(schedules && schedules.summary && schedules.summary.failures);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view reports-view rl-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      title: "Reports",
      subtitle: "Your numbers on one page, updated every time you open it. Email any report to your team on a schedule.",
      actions: /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
        onClick: () => this.props.history.push("/Reports/new")
      }, "New report")
    }), /*#__PURE__*/React.createElement("nav", {
      className: "wa-switch",
      "aria-label": "Reports views"
    }, TABS.map(([k, l]) => /*#__PURE__*/React.createElement("a", {
      key: k,
      className: "wa-tab" + (tab === k ? " on" : ""),
      style: {
        cursor: "pointer"
      },
      onClick: () => this.setTab(k)
    }, l, k === "sent" && anyFailed ? /*#__PURE__*/React.createElement("span", {
      className: "rl-dot",
      title: "An email didn't go out"
    }) : null))), note && /*#__PURE__*/React.createElement("div", {
      className: "wa-notice" + (noteKind === "error" ? " danger" : "")
    }, note), tab === "reports" && this.renderReports(), tab === "schedules" && this.renderSchedules(), tab === "sent" && this.renderSent(), sheet && /*#__PURE__*/React.createElement(ScheduleSheet, {
      report: sheet.report,
      schedule: sheet.schedule,
      onClose: () => this.setState({
        sheet: null
      }),
      onSeeAll: () => {
        this.setState({
          sheet: null
        });
        this.setTab("sent");
      },
      onChanged: () => this.load()
    }));
  }
}
export const ReportsListViewComponent = withRouter(ReportsListComponent);
export default {
  ReportsListViewComponent
};